module.exports = __webpack_public_path__ + "static/media/Reveal@2x.c49457e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ittybittyapps/Reveal@2x.png
// module id = 135
// module chunks = 0